"use client";
import { useEffect, useState } from "react";

import ArrowLeft from "@/components/icons/arrow-left";

const ScrollProgress = ({ scrollContainerRef }) => {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const scrollElement = scrollContainerRef?.current;
    if (!scrollElement) return;

    const handleScroll = () => {
      const scrollTop = scrollElement.scrollTop;
      const docHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollPercentage(progress);
      setShowButton(scrollTop > scrollElement.clientHeight * 0.1);
    };

    scrollElement.addEventListener("scroll", handleScroll);
    return () => scrollElement.removeEventListener("scroll", handleScroll);
  }, [scrollContainerRef]);

  const scrollToTop = () => {
    scrollContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    showButton && (
      <div className="fixed bottom-8 right-9 z-30 print:hidden">
        <div
          className="w-11 h-11 rounded-full scroll-behavior"
          style={{
            background: `conic-gradient(#002F2B, ${scrollPercentage}%, #ffffff ${scrollPercentage}%)`,
          }}
        >
          <div
            className="w-full h-full flex items-center justify-center text-white cursor-pointer"
            onClick={scrollToTop}
          >
            <ArrowLeft className="w-6 h-6 rotate-90" stroke="2.5" />
          </div>
        </div>
      </div>
    )
  );
};

export default ScrollProgress;
